<template lang="pug">
  .progress-steps-wrapper
    .steps
      .background-white

      .nao-travados.to-click.noselect(@click="setStep('notLocked')")
        .item-step(:class="{selected: currentStep === 'notLocked'}")
          span.circle.icon-ptt-icons-alerta(:data-badge="loading ? undefined : notLocked.length")
          span.fs-13 não travados

      .rejeitados.to-click.noselect(@click="setStep('rejected')")
        .item-step(:class="{selected: currentStep === 'rejected'}")
          span.circle(:class="lockerStates.rh_denied.classes" :data-badge="loading ? undefined : rejected.length")
          span.fs-13 rejeitados

      .confirmados.to-click.noselect(@click="setStep('confirmed')")
        .item-step(:class="{selected: currentStep === 'confirmed'}")
          span.circle(:class="lockerStates.rh_confirmed.classes" :data-badge="loading ? undefined : confirmed.length")
          span.fs-13 confirmados

      .travados.to-click.noselect(@click="setStep('locked')")
        .item-step(:class="{selected: currentStep === 'locked'}")
          span.circle(:class="lockerStates.all_confirmed.classes" :data-badge="loading ? undefined : locked.length")
          span.fs-13 travados

    .bulk-actions(v-if="showBulkOptions")
      PButton(color="primary" size="md" @click="queueSheetOfEmployees")
        span.icon-ptt-icons-folha.to-click
        | &nbsp;conferir folha dos {{$wp('employee')}}

      template(v-if="currentStep === 'notLocked'")
        PButton(color="success" size="md" v-if="permissions.confirmLock"
          :loading="executingAction.lock" @click="executeAction('lock')")
          | iniciar travamento
        PButton(color="warning" size="md" v-if="permissions.doUnilateralLock"
          :loading="executingAction.lockUnilateral" @click="executeAction('lockUnilateral')")
          | travar unilateralmente

      template(v-else-if="currentStep === 'rejected'")
        PButton(color="success" size="md" v-if="permissions.confirmLock"
          :loading="executingAction.confirm" @click="executeAction('lock')")
          | confirmar todos
        PButton(color="warning" size="md" v-if="permissions.doUnilateralLock"
          :loading="executingAction.lockUnilateral" @click="executeAction('lockUnilateral')")
          | travar unilateralmente

      template(v-else-if="currentStep === 'confirmed'")
        PButton(color="danger" size="md" v-if="permissions.rejectLock"
          :loading="executingAction.reject" @click="executeAction('reject')")
          | rejeitar todos
        PButton(color="warning" size="md" v-if="permissions.doUnilateralLock"
          :loading="executingAction.confirm" @click="executeAction('confirm')")
          | confirmar travamento

      template(v-else-if="currentStep === 'locked'")
        PButton(color="warning" size="md" v-if="permissions.doUnlocker"
          :loading="executingAction.unlock" @click="executeAction('unlock')")
          | destravar todos

</template>

<script>
import { lockerStates } from 'src/components/Sheets/Sheet/sheetUtils.js'
import { mapState } from 'vuex'

export default {
  props: {
    mode: {required: true, type: String},
    currentStep: {required: true, type: String},
    permissions: {required: true, type: Object}
  },
  data () {
    return {
      lockerStates,
      executingAction: {
        lock: false,
        confirm: false,
        reject: false,
        lockUnilateral: false,
        unlock: false
      }
    }
  },
  computed: {
    ...mapState('locker', ['notLocked', 'locked', 'rejected', 'confirmed', 'loading', 'month', 'year']),
    showBulkOptions () {
      return !this.loading && this[this.currentStep].length
    }
  },
  methods: {
    setStep (step) {
      this.$emit('changed', step)
    },
    async executeAction (operation) {
      this.executingAction[operation] = true

      await this.$store.dispatch('locker/executeAction', {viewMode: this.currentStep, applyTo: 'all', operation})

      this.executingAction[operation] = false

      this.$store.dispatch('locker/loadData', {mode: this.currentStep})
      this.$checkUserFiles()
    },
    queueSheetOfEmployees () {
      this.$router.queueEmployeesInTimesheet(
        this[this.currentStep].map(i => i.employee.id),
        new Date(this.year, this.month - 1, 1)
      )
    }
  }
}
</script>

<style scoped lang="scss">
.progress-steps-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: 1.6fr 3.5fr;
  margin: 20px 0 20px 0;

  .steps {
    display: grid;
    grid-template-columns: 0.4fr 0.4fr 0.4fr 0.4fr;

    .background-white {
      grid-column: 2/4;
      margin-left: calc(24% / 2);
      grid-row: 1;
      width: 76%;
      pointer-events: none;
      border-radius: 100px;
      opacity: .6;
      height: 70%;
      box-shadow: 0px 0px 12px -4px rgba(0,0,0,0.26);
      background-color: white;
    }

    .nao-travados {grid-column: 1}
    .rejeitados {grid-column: 2}
    .confirmados {grid-column: 3}
    .travados {grid-column: 4}

    .nao-travados, .rejeitados, .confirmados, .travados {
      grid-row: 1;
    }

    .nao-travados {
      .item-step.selected {
        span:first-child {
          align-self: center;
          background-color: var(--color-warning) !important;
        }
      }
    }
    .rejeitados {
      .item-step.selected {
        span:first-child {
          align-self: center;
          background-color: var(--color-danger) !important;
        }
      }
    }
    .confirmados {
      .item-step.selected {
        span:first-child {
          align-self: center;
          background-color: var(--color-info) !important;
        }
      }
    }
    .travados {
      .item-step.selected {
        span:first-child {
          align-self: center;
          background-color: var(--color-success) !important;
        }
      }
    }

    .item-step {
      margin-top: 7px;
      display: grid;
      grid-row-gap: 5px;
      justify-items: center;
      align-items: center;

      span:first-child {
        align-self: center;
        background-color: #e1e1e1;
      }

      &.selected {
        span:last-child {
          font-weight: bold;
        }
      }
    }
  }

  .bulk-actions {
    direction: rtl;
    display: grid;
    grid-column-gap: 10px;
    align-items: center;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    justify-items: right;
    width: 100%;
  }
}

.circle {
  height: 40px;
  width: 40px;
  font-size: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
}

.selected-color { background-color: var(--color-primary); color: white; }
.not-selected-color { background-color: lightgray; color: gray; }

[data-badge]:after {
  background: var(--color-danger);
  border-radius: 30px;
  color: #fff;
  content: attr(data-badge);
  font-weight: bold;
  font-size: 12px;
  margin-top: -10px;
  border: 2px solid var(--front-background-color);
  min-width: 13px;
  height: 14px;
  padding: 2px;
  position: absolute;
  text-align: center;
  top: 4px;
  left: 30px;
}
</style>
